export class NodeClickedEventArgs {
    public node;
    public constructor(node) {
        this.node = node;
    }
}
